import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { LocalStorageKey, PictureBackground } from "src/app/model";
import { LocalStorageService } from "../persistance";

@Injectable({ providedIn: "root" })
export class PictureBackgroundService {
  private _isPictureBackground$ = new BehaviorSubject<boolean>(false);
  isPictureBackground$ = this._isPictureBackground$.asObservable();

  constructor(private _localStorageService: LocalStorageService) {}

  initialSetupPictureBackground(): void {
    const localStorageValue = this._localStorageService.get(LocalStorageKey.PICTURE_BACKGROUND);
    const isPictureBackground = localStorageValue === PictureBackground.ON;
    this._setPictureBackground(isPictureBackground);
  }

  togglePictureBackground(): void {
    this._setPictureBackground(!this._isPictureBackground$.value);
  }

  private _setPictureBackground(pictureBackground: boolean): void {
    this._isPictureBackground$.next(pictureBackground);
    const newValue = pictureBackground ? PictureBackground.ON : PictureBackground.OFF;
    this._localStorageService.set(LocalStorageKey.PICTURE_BACKGROUND, newValue);
  }
}
